// extracted by mini-css-extract-plugin
module.exports = {"newsletter-wrapper":"Newsletter_newsletter-wrapper__Xpxvf","newsletter-wrapper-cards":"Newsletter_newsletter-wrapper-cards__asI74"};